(function($){

	/**
	 * Выделяет часть текста в тэге &lt;input&gt;.
	 * @param {int} iStart позиция с которой начать выделение
	 * @param {int} iEnd позиция, на которой закончить выделение
	 */
	$.fn.selectFromTo = function(start, end) {
	    //var e = $(this).get();
		return this.each(function()
		{
			//var e = document.getElementById($(this).attr('id')); // I don't know why... but $(this) don't want to work today :-/
			var e = this;
			if (!e) return;
			else if (e.setSelectionRange) { e.focus(); e.setSelectionRange(start, end); } /* WebKit */
			else if (e.createTextRange) { var range = e.createTextRange(); range.collapse(true); range.moveEnd('character', end); range.moveStart('character', start); range.select(); } /* IE */
			else if (e.selectionStart) { e.selectionStart = start; e.selectionEnd = end; }
		});
	};
	/****
	$.fn.selectFromTo = function (iStart, iEnd)
	{
		$(this).each(function()
		{
			domInput = document.getElementById ($(this).attr("id"));
//			console.log($(this).attr("id"));
			if (domInput && domInput.createTextRange) {
				var oRange = domInput.createTextRange();
				oRange.moveStart('character', iStart);
				oRange.moveEnd('character', iEnd);
				oRange.select();
			}
			else if (domInput && domInput.createRange) {
				var oRange = domInput.createRange();
				oRange.moveStart('character', iStart);
				oRange.moveEnd('character', iEnd);
				oRange.select();
			}
			else console.log("=((");
		} );
	};
	/***/

})(jQuery);